import PropTypes from "prop-types";
import { AlertTriangle } from "lucide-react";

/**
 * What the engine said about doing an exercise the person brought in today
 * (W3: POST prescribe/'s notices — a joint that hurts, equipment that isn't
 * listed), shown beside that exercise: in the plan editor, the plan's list
 * and the session's card.
 */
function ItemNotices({ notices }) {
  return (
    <ul className="m-0 mt-1 flex list-none flex-col gap-1 p-0 text-sm">
      {notices.map((notice) => (
        <li key={notice} className="flex items-start gap-1.5">
          <AlertTriangle aria-hidden="true" className="mt-0.5 size-4 shrink-0 text-warning" />
          <span>{notice}</span>
        </li>
      ))}
    </ul>
  );
}

ItemNotices.propTypes = {
  /** The engine's sentences, each about this exercise. */
  notices: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ItemNotices;
